import { TextFields, TextIncreaseTwoTone } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { BaseModuleSubtype, Subtype } from "./subtype";
import TextAnswerEditorPreview from "../../../components/actionModules/subtypes/textAnswer/TextAnswerEditorPreview";
import TextAnswerSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/TextAnswerSubtypeDetails";
import { ChecklistAnswerSubtypeResponse } from "./checklistAnswerSubtype";
import { TextAnswerSubtypeDataModel } from "./textAnswerSubtype";
import TextAnswerSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/TextAnswerSubtypeSummary";

export const TextAnswerModuleSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.textAnswer.name",
    type: Subtype.TextAnswerModuleSubtype,
    icon: <TextIncreaseTwoTone />,
    editableProperties: [
        {
            displayName: "actionModules.subtypes.textAnswer.hintText",
            name: "hintText",
            defaultValue: "",
            propertyType: PropertyTypes.text
        },
    ],
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<TextFields />}
        name="actionModules.subtypes.textAnswer.name" />,
    editorPreview: TextAnswerEditorPreview,
    subtypeDataView: (props) => <TextAnswerSubtypeDetails
        subtype={props.subtype as ChecklistAnswerSubtypeResponse}
        subtypeData={props.subtypeData as TextAnswerSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <TextAnswerSubtypeSummary
        subtype={props.subtype as BaseModuleSubtype}
        subtypeData={props.subtypeData as TextAnswerSubtypeDataModel} />,
};
